<div class="checkbox_item citem_1">
  <label class="checkbox_wrap">
    <input
      type="checkbox"
      name="checkbox"
      class="checkbox_inp"
      [checked]="isOn"
      (change)="changeCheckbox()">
    <span class="checkbox_mark"></span>
  </label>
</div>
